"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2013-2020 Flowhub UG
//     (c) 2011-2012 Henri Bergius, Nemein
//     NoFlo may be freely distributed under the MIT license

/* eslint-disable no-underscore-dangle */
var debug = require('debug')('noflo:component');

module.exports = /*#__PURE__*/function () {
  function ProcessInput(ports, context) {
    _classCallCheck(this, ProcessInput);

    this.ports = ports;
    this.context = context;
    this.nodeInstance = this.context.nodeInstance;
    this.ip = this.context.ip;
    this.port = this.context.port;
    this.result = this.context.result;
    this.scope = this.context.scope;
  } // When preconditions are met, set component state to `activated`


  _createClass(ProcessInput, [{
    key: "activate",
    value: function activate() {
      if (this.context.activated) {
        return;
      }

      if (this.nodeInstance.isOrdered()) {
        // We're handling packets in order. Set the result as non-resolved
        // so that it can be send when the order comes up
        this.result.__resolved = false;
      }

      this.nodeInstance.activate(this.context);

      if (this.port.isAddressable()) {
        debug("".concat(this.nodeInstance.nodeId, " packet on '").concat(this.port.name, "[").concat(this.ip.index, "]' caused activation ").concat(this.nodeInstance.load, ": ").concat(this.ip.type));
      } else {
        debug("".concat(this.nodeInstance.nodeId, " packet on '").concat(this.port.name, "' caused activation ").concat(this.nodeInstance.load, ": ").concat(this.ip.type));
      }
    } // ## Connection listing
    // This allows components to check which input ports are attached. This is
    // useful mainly for addressable ports

  }, {
    key: "attached",
    value: function attached() {
      var _this = this;

      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      var args = params;

      if (!args.length) {
        args = ['in'];
      }

      var res = [];
      args.forEach(function (port) {
        if (!_this.ports[port]) {
          throw new Error("Node ".concat(_this.nodeInstance.nodeId, " has no port '").concat(port, "'"));
        }

        res.push(_this.ports[port].listAttached());
      });

      if (args.length === 1) {
        return res.pop();
      }

      return res;
    } // ## Input preconditions
    // When the processing function is called, it can check if input buffers
    // contain the packets needed for the process to fire.
    // This precondition handling is done via the `has` and `hasStream` methods.
    // Returns true if a port (or ports joined by logical AND) has a new IP
    // Passing a validation callback as a last argument allows more selective
    // checking of packets.

  }, {
    key: "has",
    value: function has() {
      for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      var args = params;
      var validate;

      if (!args.length) {
        args = ['in'];
      }

      if (typeof args[args.length - 1] === 'function') {
        validate = args.pop();
      } else {
        validate = function validate() {
          return true;
        };
      }

      for (var i = 0; i < args.length; i += 1) {
        var port = args[i];

        if (Array.isArray(port)) {
          if (!this.ports[port[0]]) {
            throw new Error("Node ".concat(this.nodeInstance.nodeId, " has no port '").concat(port[0], "'"));
          }

          if (!this.ports[port[0]].isAddressable()) {
            throw new Error("Non-addressable ports, access must be with string ".concat(port[0]));
          }

          if (!this.ports[port[0]].has(this.scope, port[1], validate)) {
            return false;
          }
        } else {
          if (!this.ports[port]) {
            throw new Error("Node ".concat(this.nodeInstance.nodeId, " has no port '").concat(port, "'"));
          }

          if (this.ports[port].isAddressable()) {
            throw new Error("For addressable ports, access must be with array [".concat(port, ", idx]"));
          }

          if (!this.ports[port].has(this.scope, validate)) {
            return false;
          }
        }
      }

      return true;
    } // Returns true if the ports contain data packets

  }, {
    key: "hasData",
    value: function hasData() {
      for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      var args = params;

      if (!args.length) {
        args = ['in'];
      }

      args.push(function (ip) {
        return ip.type === 'data';
      });
      return this.has.apply(this, _toConsumableArray(args));
    } // Returns true if a port has a complete stream in its input buffer.

  }, {
    key: "hasStream",
    value: function hasStream() {
      var _this2 = this;

      for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }

      var args = params;
      var validateStream;

      if (!args.length) {
        args = ['in'];
      }

      if (typeof args[args.length - 1] === 'function') {
        validateStream = args.pop();
      } else {
        validateStream = function validateStream() {
          return true;
        };
      }

      var _loop = function _loop(i) {
        var port = args[i];
        var portBrackets = [];
        var hasData = false;

        var validate = function validate(ip) {
          if (ip.type === 'openBracket') {
            portBrackets.push(ip.data);
            return false;
          }

          if (ip.type === 'data') {
            // Run the stream validation callback
            hasData = validateStream(ip, portBrackets); // Data IP on its own is a valid stream

            if (!portBrackets.length) {
              return hasData;
            } // Otherwise we need to check for complete stream


            return false;
          }

          if (ip.type === 'closeBracket') {
            portBrackets.pop();

            if (portBrackets.length) {
              return false;
            }

            if (!hasData) {
              return false;
            }

            return true;
          }

          return false;
        };

        if (!_this2.has(port, validate)) {
          return {
            v: false
          };
        }
      };

      for (var i = 0; i < args.length; i += 1) {
        var _ret = _loop(i);

        if (_typeof(_ret) === "object") return _ret.v;
      }

      return true;
    } // ## Input processing
    //
    // Once preconditions have been met, the processing function can read from
    // the input buffers. Reading packets sets the component as "activated".
    //
    // Fetches IP object(s) for port(s)

  }, {
    key: "get",
    value: function get() {
      this.activate();

      for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        params[_key5] = arguments[_key5];
      }

      var args = params;

      if (!args.length) {
        args = ['in'];
      }

      var res = [];

      for (var i = 0; i < args.length; i += 1) {
        var port = args[i];
        var idx = void 0;
        var ip = void 0;
        var portname = void 0;

        if (Array.isArray(port)) {
          var _Array$from = Array.from(port);

          var _Array$from2 = _slicedToArray(_Array$from, 2);

          portname = _Array$from2[0];
          idx = _Array$from2[1];

          if (!this.ports[portname].isAddressable()) {
            throw new Error('Non-addressable ports, access must be with string portname');
          }
        } else {
          portname = port;

          if (this.ports[portname].isAddressable()) {
            throw new Error('For addressable ports, access must be with array [portname, idx]');
          }
        }

        if (this.nodeInstance.isForwardingInport(portname)) {
          ip = this.__getForForwarding(portname, idx);
          res.push(ip);
        } else {
          ip = this.ports[portname].get(this.scope, idx);
          res.push(ip);
        }
      }

      if (args.length === 1) {
        return res[0];
      }

      return res;
    }
  }, {
    key: "__getForForwarding",
    value: function __getForForwarding(port, idx) {
      var prefix = [];
      var dataIp = null; // Read IPs until we hit data

      var ok = true;

      while (ok) {
        // Read next packet
        var ip = this.ports[port].get(this.scope, idx); // Stop at the end of the buffer

        if (!ip) {
          break;
        }

        if (ip.type === 'data') {
          // Hit the data IP, stop here
          dataIp = ip;
          ok = false;
          break;
        } // Keep track of bracket closings and openings before


        prefix.push(ip);
      } // Forwarding brackets that came before data packet need to manipulate context
      // and be added to result so they can be forwarded correctly to ports that
      // need them


      for (var i = 0; i < prefix.length; i += 1) {
        var _ip = prefix[i];

        if (_ip.type === 'closeBracket') {
          // Bracket closings before data should remove bracket context
          if (!this.result.__bracketClosingBefore) {
            this.result.__bracketClosingBefore = [];
          }

          var context = this.nodeInstance.getBracketContext('in', port, this.scope, idx).pop();
          context.closeIp = _ip;

          this.result.__bracketClosingBefore.push(context);
        } else if (_ip.type === 'openBracket') {
          // Bracket openings need to go to bracket context
          this.nodeInstance.getBracketContext('in', port, this.scope, idx).push({
            ip: _ip,
            ports: [],
            source: port
          });
        }
      } // Add current bracket context to the result so that when we send
      // to ports we can also add the surrounding brackets


      if (!this.result.__bracketContext) {
        this.result.__bracketContext = {};
      }

      this.result.__bracketContext[port] = this.nodeInstance.getBracketContext('in', port, this.scope, idx).slice(0); // Bracket closings that were in buffer after the data packet need to
      // be added to result for done() to read them from

      return dataIp;
    } // Fetches `data` property of IP object(s) for given port(s)

  }, {
    key: "getData",
    value: function getData() {
      var _this3 = this;

      for (var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        params[_key6] = arguments[_key6];
      }

      var args = params;

      if (!args.length) {
        args = ['in'];
      }

      var datas = [];
      args.forEach(function (port) {
        var packet = _this3.get(port);

        if (packet == null) {
          // we add the null packet to the array so when getting
          // multiple ports, if one is null we still return it
          // so the indexes are correct.
          datas.push(packet);
          return;
        }

        while (packet.type !== 'data') {
          packet = _this3.get(port);

          if (!packet) {
            break;
          }
        }

        datas.push(packet.data);
      });

      if (args.length === 1) {
        return datas.pop();
      }

      return datas;
    } // Fetches a complete data stream from the buffer.

  }, {
    key: "getStream",
    value: function getStream() {
      for (var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        params[_key7] = arguments[_key7];
      }

      var args = params;

      if (!args.length) {
        args = ['in'];
      }

      var datas = [];

      for (var i = 0; i < args.length; i += 1) {
        var port = args[i];
        var portBrackets = [];
        var portPackets = [];
        var hasData = false;
        var ip = this.get(port);

        if (!ip) {
          datas.push(undefined);
        }

        while (ip) {
          if (ip.type === 'openBracket') {
            if (!portBrackets.length) {
              // First openBracket in stream, drop previous
              portPackets = [];
              hasData = false;
            }

            portBrackets.push(ip.data);
            portPackets.push(ip);
          }

          if (ip.type === 'data') {
            portPackets.push(ip);
            hasData = true; // Unbracketed data packet is a valid stream

            if (!portBrackets.length) {
              break;
            }
          }

          if (ip.type === 'closeBracket') {
            portPackets.push(ip);
            portBrackets.pop();

            if (hasData && !portBrackets.length) {
              // Last close bracket finishes stream if there was data inside
              break;
            }
          }

          ip = this.get(port);
        }

        datas.push(portPackets);
      }

      if (args.length === 1) {
        return datas.pop();
      }

      return datas;
    }
  }]);

  return ProcessInput;
}();